import { Link } from "../lib/router";
import { useAppStore } from "../lib/store";
import { getThemeColors } from "../lib/theme";
import { umamiEvent } from "../lib/analytics";
import { useTranslation } from "react-i18next";

interface HomeLinkProps {
  textClassName?: string;
}

export function HomeLink({ textClassName = "" }: HomeLinkProps) {
  const isDark = useAppStore((state) => state.isDark);
  const theme = getThemeColors(isDark);
  const { t } = useTranslation();

  return (
    <Link
      to="/"
      {...umamiEvent("home-link")}
      className={`
        flex items-center gap-2.5 
        cursor-pointer
        ${theme.text}
        hover:opacity-70 
        transition-all duration-200 
        focus-visible:outline-none 
        focus-visible:ring-2 
        focus-visible:ring-offset-2 
        focus-visible:ring-offset-transparent
        rounded-lg
        p-1.5
        -ml-1.5
        ${isDark ? "focus-visible:ring-white" : "focus-visible:ring-gray-900"}
      `}
    >
      <img
        src="/favicon.ico"
        alt={t("components.homeLink.alt")}
        className="w-6 h-6 block"
      />
      <span
        className={`hidden sm:block text-lg font-semibold tracking-tight ${textClassName}`}
      >
        {t("components.homeLink.text")}
      </span>
    </Link>
  );
}
